import React from 'react';
import { string, func, node } from 'prop-types';
import isNil from 'ramda/src/isNil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useFocusOnMount, ModalErrorBoundary } from 'mangools-react-components/src';

const MESSAGE_HOLDER_ID = 'MESSAGE_HOLDER_ID';

const MessageHolder = React.memo(props => {
    const closeRef = useFocusOnMount();

    const closeAll = e => {
        if (e.target.id === MESSAGE_HOLDER_ID) {
            if (!isNil(props.onClose)) {
                props.onClose();
            }
        }
    };

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
        <aside
            id={MESSAGE_HOLDER_ID}
            className="uk-modal is-message uk-open uk-display-block uk-text-center"
            role="region"
            onClick={closeAll}
        >
            <div className={classnames('uk-modal-dialog', props.classNames)} style={props.style}>
                {!isNil(props.onClose) && (
                    <button
                        ref={closeRef}
                        aria-label="Close"
                        className="mg-close"
                        onClick={props.onClose}
                        type="button"
                    >
                        <FontAwesomeIcon icon="times" aria-hidden="true" />
                    </button>
                )}
                <ModalErrorBoundary>
                    {props.children}
                </ModalErrorBoundary>
            </div>
        </aside>
    );
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
});

MessageHolder.displayName = 'MessageHolder';

MessageHolder.propTypes = {
    children: node.isRequired,
    onClose: func,
    classNames: string,
};

export default MessageHolder;
